/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LocationUniformItemWriteRequest,
  SkillUniformOptions,
  UniformCatalogItem,
  UniformsCatalogListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLocationsUniformItemsListUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/uniform-items/`
}

/**
 * GET on the collection — this location's active custom garments as a bare list,
 * shape-identical to ``GET /uniforms/catalog/`` so the builder merges the two client-side.
 * @summary List a location's custom uniform items
 */
export const locationsUniformItemsList = async (locationId: number, options?: Parameters<typeof customFetch>[1]): Promise<UniformCatalogItem[]> => {

  return customFetch<UniformCatalogItem[]>(getLocationsUniformItemsListUrl(locationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsUniformItemsListQueryKey = (locationId: number,) => {
    return [
    `/api/locations/${locationId}/uniform-items/`
    ] as const;
    }


export const getLocationsUniformItemsListQueryOptions = <TData = Awaited<ReturnType<typeof locationsUniformItemsList>>, TError = void>(locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsUniformItemsListQueryKey(locationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsUniformItemsList>>> = ({ signal }) => locationsUniformItemsList(locationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsUniformItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof locationsUniformItemsList>>>
export type LocationsUniformItemsListQueryError = void


export function useLocationsUniformItemsList<TData = Awaited<ReturnType<typeof locationsUniformItemsList>>, TError = void>(
 locationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsUniformItemsList>>,
          TError,
          Awaited<ReturnType<typeof locationsUniformItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsUniformItemsList<TData = Awaited<ReturnType<typeof locationsUniformItemsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsUniformItemsList>>,
          TError,
          Awaited<ReturnType<typeof locationsUniformItemsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsUniformItemsList<TData = Awaited<ReturnType<typeof locationsUniformItemsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a location's custom uniform items
 */

export function useLocationsUniformItemsList<TData = Awaited<ReturnType<typeof locationsUniformItemsList>>, TError = void>(
 locationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsUniformItemsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsUniformItemsListQueryOptions(locationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsUniformItemsCreateUrl = (locationId: number,) => {




  return `/api/locations/${locationId}/uniform-items/`
}

/**
 * POST on the collection — create one custom garment for this location.
 * @summary Create a custom uniform item for a location
 */
export const locationsUniformItemsCreate = async (locationId: number,
    locationUniformItemWriteRequest: LocationUniformItemWriteRequest, options?: Parameters<typeof customFetch>[1]): Promise<UniformCatalogItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UniformCatalogItem>(getLocationsUniformItemsCreateUrl(locationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(locationUniformItemWriteRequest)
  }
);}





export const getLocationsUniformItemsCreateMutationKey = () => ['locationsUniformItemsCreate'] as const;

export const getLocationsUniformItemsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsCreate>>, TError,LocationsUniformItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsCreate>>, TError,LocationsUniformItemsCreateMutationVariables, TContext> => {

const mutationKey = getLocationsUniformItemsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsUniformItemsCreate>>, LocationsUniformItemsCreateMutationVariables> = (props) => {
          const {locationId,data} = props ?? {};

          return  locationsUniformItemsCreate(locationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsUniformItemsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof locationsUniformItemsCreate>>>
    export type LocationsUniformItemsCreateMutationBody = LocationUniformItemWriteRequest
    export type LocationsUniformItemsCreateMutationError = void
    export type LocationsUniformItemsCreateMutationVariables = {locationId: number;data: LocationUniformItemWriteRequest}

    /**
 * @summary Create a custom uniform item for a location
 */
export const useLocationsUniformItemsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsCreate>>, TError,LocationsUniformItemsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsUniformItemsCreate>>,
        TError,
        LocationsUniformItemsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsUniformItemsCreateMutationOptions(options), queryClient);
    }
    export const getLocationsUniformItemsDestroyUrl = (locationId: number,
    itemId: number,) => {




  return `/api/locations/${locationId}/uniform-items/${itemId}/`
}

/**
 * DELETE on the detail route — hard-delete one of this location's custom garments.
 *
 * ``ProtectedError`` → 409 is a forward guard: today custom items have no referrers, but if
 * CORE-6264 later lets a per-location preset reference one, an in-use delete degrades to 409
 * rather than a 500.
 * @summary Delete a custom uniform item
 */
export const locationsUniformItemsDestroy = async (locationId: number,
    itemId: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getLocationsUniformItemsDestroyUrl(locationId,itemId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLocationsUniformItemsDestroyMutationKey = () => ['locationsUniformItemsDestroy'] as const;

export const getLocationsUniformItemsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsDestroy>>, TError,LocationsUniformItemsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsDestroy>>, TError,LocationsUniformItemsDestroyMutationVariables, TContext> => {

const mutationKey = getLocationsUniformItemsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof locationsUniformItemsDestroy>>, LocationsUniformItemsDestroyMutationVariables> = (props) => {
          const {locationId,itemId} = props ?? {};

          return  locationsUniformItemsDestroy(locationId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LocationsUniformItemsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof locationsUniformItemsDestroy>>>

    export type LocationsUniformItemsDestroyMutationError = void
    export type LocationsUniformItemsDestroyMutationVariables = {locationId: number;itemId: number}

    /**
 * @summary Delete a custom uniform item
 */
export const useLocationsUniformItemsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof locationsUniformItemsDestroy>>, TError,LocationsUniformItemsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof locationsUniformItemsDestroy>>,
        TError,
        LocationsUniformItemsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLocationsUniformItemsDestroyMutationOptions(options), queryClient);
    }
    export const getSkillsUniformRetrieveUrl = (skillId: number,) => {




  return `/api/skills/${skillId}/uniform/`
}

/**
 * `GET /skills/{skill_id}/uniform/` — the uniform options for a position in Request-a-Pro:
 * its default uniform's colour presets (each with default garments), the pre-selected default,
 * and the global garment catalog for the Custom builder.
 *
 * Only the position's uniform is returned (not the whole catalog). A position with no binding —
 * or one defaulting to Custom — returns `uniform: null` and `default.selection_type: "CUSTOM"`.
 * @summary Get a position's uniform options
 */
export const skillsUniformRetrieve = async (skillId: number, options?: Parameters<typeof customFetch>[1]): Promise<SkillUniformOptions> => {

  return customFetch<SkillUniformOptions>(getSkillsUniformRetrieveUrl(skillId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSkillsUniformRetrieveQueryKey = (skillId: number,) => {
    return [
    `/api/skills/${skillId}/uniform/`
    ] as const;
    }


export const getSkillsUniformRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError = void>(skillId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSkillsUniformRetrieveQueryKey(skillId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof skillsUniformRetrieve>>> = ({ signal }) => skillsUniformRetrieve(skillId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: skillId !== null && skillId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SkillsUniformRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof skillsUniformRetrieve>>>
export type SkillsUniformRetrieveQueryError = void


export function useSkillsUniformRetrieve<TData = Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError = void>(
 skillId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUniformRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsUniformRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsUniformRetrieve<TData = Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError = void>(
 skillId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof skillsUniformRetrieve>>,
          TError,
          Awaited<ReturnType<typeof skillsUniformRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSkillsUniformRetrieve<TData = Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError = void>(
 skillId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a position's uniform options
 */

export function useSkillsUniformRetrieve<TData = Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError = void>(
 skillId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof skillsUniformRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSkillsUniformRetrieveQueryOptions(skillId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUniformsCatalogListUrl = (params?: UniformsCatalogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/uniforms/catalog/?${stringifiedParams}` : `/api/uniforms/catalog/`
}

/**
 * `GET /uniforms/catalog/` — the global garment catalog for the Custom builder. Byte-identical
 * across positions, so it is its own cacheable endpoint rather than riding inline on the
 * per-position `/skills/{id}/uniform/` response.
 *
 * An optional `color_scheme` query param scopes the catalog to items offered under that scheme
 * (`UniformItem.color_schemes` overlap — see `UniformCatalogFilter`). Omitting it, or an invalid
 * value, is handled by `DjangoFilterBackend` (400 on an invalid choice). Unpaginated — this is a
 * small, cacheable reference list, not a paginated collection.
 * @summary Get the global uniform item catalog
 */
export const uniformsCatalogList = async (params?: UniformsCatalogListParams, options?: Parameters<typeof customFetch>[1]): Promise<UniformCatalogItem[]> => {

  return customFetch<UniformCatalogItem[]>(getUniformsCatalogListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUniformsCatalogListQueryKey = (params?: UniformsCatalogListParams,) => {
    return [
    `/api/uniforms/catalog/`, ...(params ? [params] : [])
    ] as const;
    }


export const getUniformsCatalogListQueryOptions = <TData = Awaited<ReturnType<typeof uniformsCatalogList>>, TError = void>(params?: UniformsCatalogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniformsCatalogListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof uniformsCatalogList>>> = ({ signal }) => uniformsCatalogList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UniformsCatalogListQueryResult = NonNullable<Awaited<ReturnType<typeof uniformsCatalogList>>>
export type UniformsCatalogListQueryError = void


export function useUniformsCatalogList<TData = Awaited<ReturnType<typeof uniformsCatalogList>>, TError = void>(
 params: undefined |  UniformsCatalogListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof uniformsCatalogList>>,
          TError,
          Awaited<ReturnType<typeof uniformsCatalogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniformsCatalogList<TData = Awaited<ReturnType<typeof uniformsCatalogList>>, TError = void>(
 params?: UniformsCatalogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof uniformsCatalogList>>,
          TError,
          Awaited<ReturnType<typeof uniformsCatalogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUniformsCatalogList<TData = Awaited<ReturnType<typeof uniformsCatalogList>>, TError = void>(
 params?: UniformsCatalogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the global uniform item catalog
 */

export function useUniformsCatalogList<TData = Awaited<ReturnType<typeof uniformsCatalogList>>, TError = void>(
 params?: UniformsCatalogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof uniformsCatalogList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUniformsCatalogListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






